import {
	Component, Input, OnInit, OnChanges, SimpleChanges, SimpleChange,
	ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import {
	InfoSetView, InfoSetViewColumn, InfoSetViewEntry, InfoSetViewValue
} from 'UvExplorerServer.Dtos.TS/Session';
import { DateService } from 'base';
import { StringUtils } from 'DiscoveryEngine.TS/Utils';
import { IdentityService } from 'identity';
import { DiscResultsService } from 'discovery';

@Component({
    selector: 'notes-info-viewer',
	templateUrl: './notesinfoviewer.component.html',
	styleUrls: ['./notesinfoviewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotesInfoViewerComponent implements OnInit, OnChanges {

	@Input()
	public deviceGuid: string;

	@Input()
	public deviceName: string;

	@Input()
	public infoSetView: InfoSetView;

	public entries: any[];
	public name: string;
	public notes: string;
	public displayViewNotesDialog: boolean;

	constructor(private changeDetector: ChangeDetectorRef,
		private dateService: DateService,
		private identityService: IdentityService,
		private discResultsService: DiscResultsService ) {

		this.displayViewNotesDialog = false;

		this.resetNotesProps();

		// Force infoset viewer to update its contents (bug work-around)
		setTimeout(() => {
			this.updateData();
			this.changeDetector.markForCheck();
		}, 0);
	}

	private resetNotesProps(): void {
		this.name = "";
		this.notes = "";
	}

	private readonly ObfuscateConfigs = false;

	private setNotesPropsFromEntry(entry): void {
		this.name = entry.name;
		this.notes = entry.notes;
	}

	public viewConfig(event, entry): void {
		event.stopPropagation();
		this.setNotesPropsFromEntry(entry);
		this.displayViewNotesDialog = true;
	}

	public closeViewConfigDialog(): void {
		this.displayViewNotesDialog = false;
		this.resetNotesProps();
	}

	public ngOnInit(): void {
		this.updateData();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change = changes["infoSetView"];

		if (change) {
			this.updateData();
		}
	}

	private updateData(): void {
		this.entries = [];

		if (this.infoSetView) {

			// Initialize entries
			this.infoSetView.entries.forEach((viewEntry: InfoSetViewEntry) => {
				let entry: any = {};

				entry.name = viewEntry.values[0].value;
				entry.notes = viewEntry.values[1].value;

				this.entries.push(entry);
			}, this);
		}
	}

	public doCustomSort(event): void {
		let _self = this;
		let comparer = function (a: any, b: any): number {

			let result = 0;
			if (event.field == "name") {
				let aVal: string = a[event.field];
				let bVal: string = b[event.field];
				result = _self.compareStrings(aVal, bVal);
			}
			if (event.field == "notes") {
				let aVal: string = a[event.field];
				let bVal: string = b[event.field];
				result = _self.compareStrings(aVal, bVal);
			}
			else {
				throw new Error("Invalid sort field: " + event.field);
			}

			return result * event.order;
		}

		this.entries.sort(comparer);
	}

	protected compareStrings(a: string, b: string): number {
		if (a && b)
			return a.localeCompare(b);
		else if (a)
			return 1;
		else if (b)
			return -1;
		else
			return 0;
	}

}
